import i18n from 'i18next';
import ChainedBackend from 'i18next-chained-backend';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import resources from './resources';

const appLanguage = document.getElementById('viato-contract-generator').dataset.lng;
const urlPrefix = process.env.NODE_ENV !== 'production' ? '' : 'https://contract-generator.viato.travel';

i18n.use(ChainedBackend)
	.use(initReactI18next)
	.init({
		lng: appLanguage,
		debug: process.env.NODE_ENV !== 'production',
		returnObjects: true,
		fallbackLng: 'de',
		supportedLngs: ['en', 'de'],
		keySeparator: '.',
		interpolation: {
			escapeValue: false
		},
		react: {
			useSuspense: true,
			transEmptyNodeValue: '', // what to return for empty Trans
			transSupportBasicHtmlNodes: true // allow <br/> and simple html elements in translations
		},
		backend: {
			backends: [HttpBackend],
			backendOptions: [
				{
					loadPath: `${urlPrefix}/api/languageVariables/{{lng}}`
				}
			]
		}
	});

i18n.addResourceBundle('de', 'app', {
	...resources.de.app
});

i18n.addResourceBundle('de', 'contractGenerator', {
	...resources.de.contractGenerator
});

i18n.addResourceBundle('de', 'viatoUi', {
	...resources.de.viatoUi
});

i18n.addResourceBundle('en', 'app', {
	...resources.en.app
});

i18n.addResourceBundle('en', 'contractGenerator', {
	...resources.en.contractGenerator
});

i18n.addResourceBundle('en', 'viatoUi', {
	...resources.en.viatoUi
});

export default i18n;
